import React, { useState } from 'react';
import { Button } from '../../Elements';
import commonNetwork from '../../../../common/api/commonNetwork';
import { ApiResponseType } from '../../../../common/api/apiHelper';
import { toast } from 'react-toastify';
import { errorMessages } from '../../../../constants/messages/errorMessages';

const DownloadExcel = () => {
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [postLoading, setPostLoading] = useState<boolean>(false);

    const onErrorDownloadFile = () => {
        setShowAlert(true);
        setTimeout(() => {
            setShowAlert(false);
        }, 3000);
    };

    const getFileName = () => {
        return "etahsilat_musteri_excel.xlsx";
    };

    const handleDownload = async () => {
        setPostLoading(true);
        let result: ApiResponseType;

        try {
            result = await commonNetwork.downloadFileGetRequest("/customer/download-excel");

            if (result.isSuccess) {
                const blob = new Blob([result.data]);
                const href = URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = href;
                link.setAttribute('download', getFileName());
                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                URL.revokeObjectURL(href);
            } else {
                toast.error(result.errorMessage);
             
            }
        } catch (error) {
            console.error("Download error:", error);
            onErrorDownloadFile();
        } finally {
            setPostLoading(false);
        }
    };

    return (
        <>
            <Button
                size="xs"
                hover="primary"
                color="primary"
                callback={handleDownload}
                disabled={postLoading}
                loading={postLoading}
            >
                <img src="/icons/download.svg" alt="exampleExcelFile" />
                <span className='ml-3'>Örnek Excel Dosyasını İndir</span>
            </Button>
            {showAlert && <div style={{ color: 'red' }}>İnternet bağlantınızı kontrol edin</div>}
        </>
    );
};

export default DownloadExcel;
